<template>
  <div class="cart-wrapper pb-4">
    <cart-products-list
      :cartProducts="productsData"
      :cartCount="productCount"
      :disabled="disabled"
    >
    </cart-products-list>
    <div v-if="$route.path !== '/checkout'">
      <cart-summary
        :cartTotal="totalPrice"
        :cartTotalOffer="totalOffer"
        :cartItemsTotal="totalCartPrice"
        :cartCount="productCount"
        v-if="(getCartCount > 0 || getBuyNowProductCount > 0)"
      >
      </cart-summary>
    </div>
    <mobile-cart-footer
      :cartTotal="totalPrice"
      :cartProducts="productsData"
      :cartCount="productCount"
      v-if="(getCartCount > 0 || getBuyNowProductCount > 0) &&
                         $route.path === '/cart'"
    >
    </mobile-cart-footer>
  </div>
</template>

<script>
import MobileCartFooter from '@/components/pages/cart/cartContainer/widgets/MobileCartFooter'
import CartProductsList from '@/components/pages/cart/cartContainer/cartProductList/CartProductsList'
import CartSummary from '@/components/pages/cart/cartContainer/cartSummary/CartSummary'
import { mapGetters } from 'vuex'

export default {
	components: {
		CartProductsList,
		CartSummary,
		MobileCartFooter
	},
	computed: {
		...mapGetters('cart', ['getCartCount']),
		...mapGetters('buynow', ['getBuyNowProductCount'])
	},
	props: {
		productsData: null,
		productCount: {
			default: 0,
			type: Number
		},
		totalPrice: {
			default: 0,
			type: Number
		},
		totalOffer: {
			default: 0,
			type: Number
		},
		totalCartPrice: {
			default: 0,
			type: Number
		},
		disabled: {
			type: Boolean,
			default: false
		}
	}
}
</script>
